import { api } from '../api/client.js';

export const listImports = () => api.get('/commissions').then((r) => r.data.data.imports);
export const createImport = (payload) => api.post('/commissions', payload).then((r) => r.data.data);
export const createRow = (payload) => api.post('/commissions/row', payload).then((r) => r.data.data);
